/** @flow */

import {
  GetStandardQuestions,
  GetStandardQuestionsSuccess,
  GetStandardQuestionsError,
  NewStandardQuestion,
  ShowAddStandardQuestionModal,
  UpdateStandardQuestionDraft,
  SetStandardQuestionRevisionSchema,
  GetStandardQuestionActiveSuccess,
  GetStandardQuestionActiveError,
  SetStandardQuestionAssignments,
  SetStandardQuestionStatus,
  GetStandardQuestion,
  GetStandardQuestionSuccess,
  GetStandardQuestionError,
  ShowStandardQuestionEditModal,
  SetShowSubmitStandardQuestionModal,
  SubmitStandardQuestionForReviewError,
  SetShowCancelStandardQuestionModal,
  CancelStandardQuestionReviewError,
  StartStandardQuestionDraftSuccess,
  SetShowDiscardStandardQuestionModal,
  SetShowCancelDiscardStandardQuestionModal,
  DuplicateStandardQuestionSuccess,
  SetShowDisableStandardQuestionModal,
  StartStandardQuestionDraftError,
  DiscardStandardQuestionDraftError,
  DuplicateStandardQuestionError,
  CancelStandardQuestionReviewAndDiscardError,
  DisableStandardQuestionError,
  UpdateStandardQuestionAssignmentsError,
  ShowEditStandardQuestionAssignmentsModal,
  SetStandardQuestionDraftAssignments,
  UpdateStandardQuestion,
  UpdateStandardQuestionSuccess,
  UpdateStandardQuestionError,
  AddNewStandardQuestion,
  AddNewStandardQuestionSuccess,
  AddNewStandardQuestionError,
} from "@modules/service/constants/actions";
import * as standardQuestionsReducers from "./reducers";
import initialState from "./state";
import type { StandardQuestionsState } from "./types";
import { cloneObject } from "@utils/object";

export default (
  state: StandardQuestionsState = initialState,
  action: Object,
): StandardQuestionsState => {
  const act = {
    [AddNewStandardQuestion]: standardQuestionsReducers.onAddNewStandardQuestion,
    [AddNewStandardQuestionSuccess]: standardQuestionsReducers.onAddNewStandardQuestionSuccess,
    [AddNewStandardQuestionError]: standardQuestionsReducers.onAddNewStandardQuestionError,
    [UpdateStandardQuestion]: standardQuestionsReducers.onUpdateStandardQuestion,
    [UpdateStandardQuestionSuccess]: standardQuestionsReducers.onUpdateStandardQuestionSuccess,
    [UpdateStandardQuestionError]: standardQuestionsReducers.onUpdateStandardQuestionError,
    [GetStandardQuestions]: standardQuestionsReducers.onGetStandardQuestions,
    [GetStandardQuestionsSuccess]: standardQuestionsReducers.onGetStandardQuestionsSuccess,
    [GetStandardQuestionsError]: standardQuestionsReducers.onGetStandardQuestionsError,
    [GetStandardQuestionsSuccess]: standardQuestionsReducers.onGetStandardQuestionsSuccess,
    [GetStandardQuestionsError]: standardQuestionsReducers.onGetStandardQuestionsError,
    [NewStandardQuestion]: standardQuestionsReducers.onNewStandardQuestion,
    [ShowAddStandardQuestionModal]: standardQuestionsReducers.onShowAddStandardQuestionModal,
    [UpdateStandardQuestionDraft]: standardQuestionsReducers.onUpdateStandardQuestionDraft,
    [SetStandardQuestionRevisionSchema]:
      standardQuestionsReducers.onSetStandardQuestionRevisionSchema,
    [GetStandardQuestionActiveSuccess]:
      standardQuestionsReducers.onGetStandardQuestionActiveSuccess,
    [GetStandardQuestionActiveError]: standardQuestionsReducers.onGetStandardQuestionActiveError,
    [SetStandardQuestionAssignments]: standardQuestionsReducers.onSetStandardQuestionAssignments,
    [SetStandardQuestionDraftAssignments]:
      standardQuestionsReducers.onSetStandardQuestionDraftAssignments,
    [SetStandardQuestionStatus]: standardQuestionsReducers.onSetStandardQuestionStatus,
    [GetStandardQuestion]: standardQuestionsReducers.onGetStandardQuestion,
    [GetStandardQuestionSuccess]: standardQuestionsReducers.onGetStandardQuestionSuccess,
    [GetStandardQuestionError]: standardQuestionsReducers.onGetStandardQuestionError,
    [ShowStandardQuestionEditModal]: standardQuestionsReducers.onShowStandardQuestionEditModal,
    [SetShowSubmitStandardQuestionModal]:
      standardQuestionsReducers.onSetShowSubmitStandardQuestionModal,
    [SetShowCancelStandardQuestionModal]:
      standardQuestionsReducers.onSetShowCancelStandardQuestionModal,
    [SubmitStandardQuestionForReviewError]:
      standardQuestionsReducers.onSubmitStandardQuestionForReviewError,
    [CancelStandardQuestionReviewError]:
      standardQuestionsReducers.onCancelStandardQuestionReviewError,
    [StartStandardQuestionDraftSuccess]:
      standardQuestionsReducers.onStartStandardQuestionDraftSuccess,
    [SetShowDiscardStandardQuestionModal]:
      standardQuestionsReducers.onSetShowDiscardStandardQuestionModal,
    [SetShowCancelDiscardStandardQuestionModal]:
      standardQuestionsReducers.onSetShowCancelDiscardStandardQuestionModal,
    [DuplicateStandardQuestionSuccess]:
      standardQuestionsReducers.onDuplicateStandardQuestionSuccess,
    [SetShowDisableStandardQuestionModal]:
      standardQuestionsReducers.onSetShowDisableStandardQuestionModal,
    [StartStandardQuestionDraftError]: standardQuestionsReducers.onStartStandardQuestionDraftError,
    [DiscardStandardQuestionDraftError]:
      standardQuestionsReducers.onDiscardStandardQuestionDraftError,
    [DuplicateStandardQuestionError]: standardQuestionsReducers.onDuplicateStandardQuestionError,
    [CancelStandardQuestionReviewAndDiscardError]:
      standardQuestionsReducers.onCancelStandardQuestionReviewAndDiscardError,
    [DisableStandardQuestionError]: standardQuestionsReducers.onDisableStandardQuestionError,
    [UpdateStandardQuestionAssignmentsError]:
      standardQuestionsReducers.onUpdateStandardQuestionAssignmentsError,
    [ShowEditStandardQuestionAssignmentsModal]:
      standardQuestionsReducers.onShowEditStandardQuestionAssignmentsModal,
  };
  if (action && action.type && act && act[action.type]) {
    return act[action.type](cloneObject(state))(action);
  }
  return state;
};
